import React from 'react';
import ListarMotores from '../../../components/insumos/motores/ListarMotores';

const ListarMotoresPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
      <ListarMotores />
    </div>
  );
};

export default ListarMotoresPage;